<template>
	<div class="target flex justify-between">
		<div class="postion" v-for="(item,index) in targetList" :key="index">
			<img class="pos-line" src="@/assets/images/index/line.png" />
			<img class="pos-logo" src="@/assets/images/index/evaluation_logo.png" />
			<div style="flex: 1;">
				<!-- <p class="counts">{{ item.counts }}</p> -->
				<dv-digital-flop class="num" style="height: 60px" :config="dvDigitalFlopConfig(item)" />
				<p class="text">{{ item.text }}</p>
			</div>
			<div class="icon">
				<img
					:src="item.icon"
					:style="{ width: item.width, height: item.height }" />
			</div>
		</div>
	</div>
</template>
<script>
import { dataInterface } from '@/api/dataInterfaceApi'
import vehicleAll from '@/assets/images/comm/vehicleAll.png'
import carbonEmissionsAll from '@/assets/images/comm/carbonEmissionsAll.png'
import mileageAll from '@/assets/images/comm/mileageAll.png'
import electricityAll from '@/assets/images/comm/electricityAll.png'
export default {
	data() {
		return {
			romData: {},
			targetInterval: null,
			targetList: [
				{
					counts: '',
					text:"车辆总数（辆）",
					icon: vehicleAll,
					width: '90px'
				},
				{
					counts: '',
					text:"碳减排（CC）",
					icon: carbonEmissionsAll,
					width: '90px'
				},
				{
					counts: '',
					text:"总行驶里程（km）",
					icon: mileageAll,
					height: '70px'
				},
				{
					counts: '',
					text:"总放电量（kwh）",
					icon: electricityAll,
					height: '70px'
				}
			]
		};
	},
	components: {},
	props: {},
	watch: {},
	mounted() {
	},
	methods: {
        dvDigitalFlopConfig(item = {}) {
            let counts = parseFloat(item.counts || 0)
			let cWidth = document.documentElement.clientWidth
            let config = {
                number: [parseFloat(counts)],
                textAlign: item.textAlign || 'left',
                // content: number > 10000 ? '{nt}w' : '{nt}',
                style: {
                    fill: item.color || '#fff',
                    fontSize: cWidth < 2000 ? 40 : 60,
					fontFamily: 'DS-Digital-Bold'
                }
            }
            return config
        },
		// 初始化
		getData(data) {
			console.log('adfadfadsf', data)
			this.romData = data
			// 车辆总数
			this.vehicleAll(data)
			// 碳减排量
			this.carbonEmissionsAll(data)
			// 总里程
			this.mileageAll(data)
			// 总电量
			this.electricityAll(data)
			// 定时器
			this.openInterval(data)
		},
		// 定时器
		openInterval(data) {
			clearInterval(this.targetInterval)
			
			this.targetInterval = setInterval(() => {
				this.getData(data)
			}, 25000)
		},
		// 车辆总数
		vehicleAll(data = {}) {
			let params = {}
			let query = this.$route.query
			params = {
				'enCode': 'quanguo_shengshi-车辆总数',
				'@VEHICLE_TYPE': query.vehicle == '1' ? '乘用车' : (query.vehicle == '2' ? '商用车' : '全部'),
				'@ADCODE': (data ? data.province || data.city || data.adcode : '') || '000000'
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res) return
				let data = res && res[0] || {}
				this.targetList[0].counts = parseInt(data.total_vehicle_num, 10)
			})
			.catch((err) => {
				console.log(err);
			});
		},
		// 碳减排量
		carbonEmissionsAll(data = {}) {
			let params = {}
			let query = this.$route.query
			params = {
				'enCode': 'quanguo_shengshi-碳减排量',
				'@VEHICLE_TYPE': query.vehicle == '1' ? '乘用车' : (query.vehicle == '2' ? '商用车' : '全部'),
				'@ADCODE': (data ? data.province || data.city || data.adcode : '') || '000000'
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res) return
				let data = res && res[0] || {}
				this.targetList[1].counts = parseInt(data.carbon_emissions_cc, 10)
			})
			.catch((err) => {
				console.log(err);
			});
		},
		// 总里程
		mileageAll(data = {}) {
			let params = {}
			let query = this.$route.query
			params = {
				'enCode': 'quanguo_shengshi-总里程',
				'@VEHICLE_TYPE': query.vehicle == '1' ? '乘用车' : (query.vehicle == '2' ? '商用车' : '全部'),
				'@ADCODE': (data ? data.province || data.city || data.adcode : '') || '000000'
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res) return
				let data = res && res[0] || {}
				this.targetList[2].counts = parseInt(data.total_consumption_mileage, 10)
			})
			.catch((err) => {
				console.log(err);
			});
		},
		// 总电量
		electricityAll(data = {}) {
			let params = {}
			let query = this.$route.query
			params = {
				'enCode': 'quanguo_shengshi-总电量',
				'@VEHICLE_TYPE': query.vehicle == '1' ? '乘用车' : (query.vehicle == '2' ? '商用车' : '全部'),
				'@ADCODE': (data ? data.province || data.city || data.adcode : '') || '000000'
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res) return
				let data = res && res[0] || {}
				this.targetList[3].counts = parseInt(data.total_consumption_elect, 10)
			})
			.catch((err) => {
				console.log(err);
			});
		},
	},
	destroyed() {
		clearInterval(this.targetInterval)
		console.log('清除定时器：12312312313131313123123123', this.targetInterval)
		this.targetInterval = null
	}
}
</script>
<style lang="scss" scoped>
@font-face {
    font-family: 'DS-Digital-Bold';
    src: url('~@/assets/font/DS-Digital-Bold.ttf');
}
.target {
	width: 100%;
	height: 122px;
	display: flex;
	margin-top: 20px;
	// margin-bottom:30px;
	.postion {
		margin: 0 20px;
		flex: 1;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-right: 20px;
		background: linear-gradient(180deg, rgba(47, 164, 159, 0.11) 0%, rgba(1, 177, 169, 0.06) 79%, rgba(53, 149, 147, 0.11) 100%);
		.pos-line {
			width: 6px;
			height: 62px;
		}
		.pos-logo {
			width: 32px;
			height: 32px;
			margin: 0 30px 0 15px;
		}
	}
	.icon {
		width: 100px;
		flex-shrink: 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.counts {
		font-size: 30px;
	}
	.text {
		font-size: 16px;
	}
}
</style>